module.exports = __webpack_public_path__ + "static/img/1.570a9af.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/1.png
// module id = gZcF
// module chunks = 0